<template>
    <Switch v-model="enabled" class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full">
        <span class="sr-only">Use setting</span>
        <span aria-hidden="true" class="pointer-events-none absolute h-full w-full rounded-md bbg-secondary-700" />
        <span aria-hidden="true" :class="[enabled ? 'bg-primary-600' : 'bg-gray-200', 'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out']" />
        <span aria-hidden="true" :class="[enabled ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out']" />
    </Switch>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue'
import { Switch } from '@headlessui/vue'

const props = defineProps(['enabled'])
const emit = defineEmits(['update'])

const enabled = ref(props.enabled)

watch(enabled, res =>{
    emit('update', res)
})

</script>